class ProductCardQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.onAddClick = this.onAddClick.bind(this);
  }
 
  connectedCallback() {
    this.button = this.querySelector('[data-quick-add]');
    if (!this.button) return;
 
    this.variantId = this.button.dataset.variantId;
    this.defaultLabel = this.button.textContent;
    this.button.addEventListener('click', this.onAddClick);
  }
 
  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.onAddClick);
    }
  }
 
  onAddClick() {
    if (!this.variantId || this.button.disabled) return;
 
    this.button.disabled = true;
    this.button.textContent = 'Agregando...';
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantId, quantity: 1 })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'No se pudo agregar');
        }
 
        this.button.textContent = 'Agregado ✓';
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
 
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const countEl = document.querySelector('[data-cart-count]');
            if (countEl) countEl.textContent = cart.item_count;
          })
          .catch(() => {});
 
        window.setTimeout(() => {
          this.button.textContent = this.defaultLabel;
          this.button.disabled = false;
        }, 2000);
      })
      .catch(() => {
        this.button.textContent = 'Reintentar';
        this.button.disabled = false;
      });
  }
}
 
if (!customElements.get('product-card-quick-add')) {
  customElements.define('product-card-quick-add', ProductCardQuickAdd);
}